import { getAddressDisplayNames } from '@hero/core';
import { AddressComponent, Order } from '@hero/schema';

export const useOrderDestination = (destinations: Order['destinations']) => {
  const firstPickup = destinations.find(d => d.type === 'pickup') || destinations[0];

  const lastDropoff =
    destinations.find(d => d.type === 'dropoff') || destinations[destinations.length - 1];

  const getDisplayDestination = (destination: Order['destinations'][0]) => {
    return getAddressDisplayNames(destination.address);
  };

  const firstPickupDisplay = getDisplayDestination(firstPickup);

  const lastDropoffDisplay = getDisplayDestination(lastDropoff);

  return {
    firstPickupDisplay,
    lastDropoffDisplay,
    getDisplayDestination,
    lastDropoff,
    firstPickup,
  };
};
